import {connect} from 'react-redux';
import VirtualEntryBowlerList from './VirtualEntryBowlerList.jsx';
import {handleUpdateVirtualEntry, handleVirtualEntryBowlerChange} from '../shared/actions';
import {closeVirtualEntryEditing} from '../shared/actionTypes';

const mapStateToProps = (state, props) => ({
  virtualEventId: state.registration.shared.virtualEntries[0].virtualEventId,
  source: state.registration.shared.virtualBowlers,
  bowlers: state.registration.shared.bowlers,
  submitting: state.registration.shared.submittingVirtualBowlers,
  showCalculatedDivisionToCaptain: state.registration.base.showCalculatedDivisionToCaptain,
  ...props
});

const mapDispatchToProps = dispatch => ({
  onVirtualEntryBowlerChange: (virtualEntryId, bowlerId) => dispatch(handleVirtualEntryBowlerChange(virtualEntryId, bowlerId)),
  onCancelClick: () => dispatch(closeVirtualEntryEditing()),
  onUpdateClick: virtualEventId => dispatch(handleUpdateVirtualEntry(virtualEventId))
});

export default connect(mapStateToProps, mapDispatchToProps)(VirtualEntryBowlerList);



// WEBPACK FOOTER //
// ./src/features/registration/manage/VirtualEntryBowlerListContainer.jsx